export abstract class BaseError extends Error {
  public readonly timestamp: Date;
  public readonly stack?: string;

  constructor(
    message: string,
    public readonly code: string,
    public readonly statusCode?: number
  ) {
    super(message);
    this.name = this.constructor.name;
    this.timestamp = new Date();
    
    if ((Error as any).captureStackTrace) {
      (Error as any).captureStackTrace(this, this.constructor);
    }
  }

  toJSON() {
    return {
      name: this.name,
      message: this.message,
      code: this.code,
      statusCode: this.statusCode,
      timestamp: this.timestamp.toISOString(),
      stack: this.stack
    };
  }
}

export class AuthError extends BaseError {
  constructor(message: string, code: string = 'AUTH_ERROR', statusCode: number = 401) {
    super(message, code, statusCode);
  }
}

export class LoginError extends AuthError {
  constructor(message: string = 'Credenciais inválidas') {
    super(message, 'LOGIN_ERROR', 401);
  }
}

export class AccessDeniedError extends AuthError {
  constructor(message: string = 'Acesso negado') {
    super(message, 'ACCESS_DENIED', 403);
  }
}

export class TokenExpiredError extends AuthError {
  constructor(message: string = 'Token expirado') {
    super(message, 'TOKEN_EXPIRED', 401);
  }
}